import {localizedFormats} from "./localizedFormats";

import type {FormatString} from "./localizedFormats";
import type {PluginFunc} from "dayjs";

declare module "dayjs" {
    interface Dayjs {
        /**
         * Get the formatted date string, localised to the current locale
         */
        format(formatStr?: FormatString): string;
    }
}

const isValidFormatString = (formatStr: string): formatStr is FormatString =>
    formatStr in localizedFormats;

export const customFormat: PluginFunc = (option, dayjsClass, dayjsFactory) => {
    const originalFormat: (template?: string) => string = dayjsClass.prototype.format;

    dayjsClass.prototype.format = function localisedFormat(formatStr?: string) {
        if (!formatStr) {
            return originalFormat.call(this, formatStr);
        }

        if (isValidFormatString(formatStr)) {
            const locale = this.locale();
            return originalFormat.call(this, localizedFormats[formatStr][locale]);
        }
        // enable this when we want to force the usage of the supported format strings
        // if (process.env.NODE_ENV !== "production") {
        //     throw new Error(
        //         `Invalid format string: ${formatStr}\n You must use one of the supported format strings`,
        //     );
        // }
        return originalFormat.call(this, formatStr);
    };
};
